
function openPopup(pUrl, pWidth, pHeight) {
    if (!pWidth)  pWidth = 800;
    if (!pHeight) pHeight = 600;

    var sWidth  = screen.availWidth;
    var sHeight = screen.availHeight;
    var pTop    = sHeight / 2 - pHeight / 2;
    var pLeft   = sWidth / 2 - pWidth / 2;

    window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' +
                    ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}


function checkSidebarHeight() {
	$('.sidebar').each(function() {
		var sidebarHeight = $(this).outerHeight(true);
		var windowHeight  = $(window).height();

		windowHeight -= $('.navbar-fixed-top').outerHeight();

		if (sidebarHeight > windowHeight) {
			$(this).addClass('no-affix');
		} else {
			$(this).removeClass('no-affix');
		}
	});
}


function printOnly($element) {
    $('body').addClass('print-nothing');
    $element.addClass('print');
    window.print();
    $element.removeClass('print');
    $('body').removeClass('print-nothing');
}


function isScrolledIntoView($element) {
    if ($element.length == 0 || !$element.is(':visible')) {
    	return false;
	}

    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $element.offset().top;
    var elemBottom = elemTop + $element.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}


function getScrollbarWidth($element) {
    var remove = false;

    if (typeof($element) == undefined) {
        remove = true;
        var $element = $('<div style="height:1px;overflow-y:scroll;"/>').appendTo('body');
    }

    var scrollbarWidth = $element[0].offsetWidth - $element[0].clientWidth;
    if (remove) $element.remove();
    return scrollbarWidth;
}


function smoothScrollTo($element, offset) {
    if ($element.length === 0) return;

	$('html').get(0).scrollTo({
		top: $element.offset().top + (offset === undefined ? 0 : parseInt(offset)),
		behavior: 'auto',
	});
}


function smoothScrollToCenter($element, offset) {
	if ($element.length === 0) return;

    offset -= $(window).height() / 2;
    smoothScrollTo($element, offset);
}


function checkDateInputs() {
    $('.input-group-date').each(function() {
		if ($(this).data('date-inputs')) {
			return;
		}

		var $group      = $(this);
		var $input      = $group.siblings('input')
        var $inputDay   = $group.find('.input-day');
        var $inputMonth = $group.find('.input-month');
        var $inputYear  = $group.find('.input-year');

		$input.attr('type', 'text').addClass('d-none');
		$group.removeClass('d-none');

		var inputFocus  = function($field) {
			$field.trigger('focus');
			$field.attr('type', 'text');
			$field.get(0).setSelectionRange($field.val().length, $field.val().length);
			$field.attr('type', 'number');
		};

		$(this).find('input[type=number]').on('keydown', function(e) {
			["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault();

		}).on('input init', function(e) {
			var value = parseInt($(this).val());
			var min = $(this).attr('min') || false;
			var max = $(this).attr('max') || false;

			if (min !== false && value < min) $(this).val(min);
			if (max !== false && value > max) $(this).val(max);

			var entered = $inputYear.val() + '-' + $inputMonth.val() + '-' + $inputDay.val();
			if (entered === '--') entered = '';

			$input.val(entered).trigger(e.type);
		}).trigger('init');

		$group.on('focusout init', function(e) {
			if ($(e.relatedTarget).closest($group).length) {
				// er is gefocused op een van de andere datumvelden, dan nog niet de datum valideren
				return;
			}

			if (e.type !== 'init') {
				$input.trigger('change');
			}
		}).trigger('init');

        $inputDay.on('keyup', function(e) {
			if ($(this).val().length === 2 && !isNaN(parseInt(e.key))) {
				inputFocus($inputMonth);
			}
		});

		$inputMonth.on('keyup', function(e) {
			if ($(this).val().length === 2 && !isNaN(parseInt(e.key))) {
				inputFocus($inputYear);
			}
		}).on('keydown', function(e) {
			if ($(this).val().length === 0 && e.keyCode === 8) {
				inputFocus($inputDay);
			}
		});

		$inputYear.on('keydown', function(e) {
			if ($(this).val().length === 0 && e.keyCode === 8) {
				inputFocus($inputMonth);
			}
		});

		$(this).data('date-inputs', true);
    });
}
